/**
 * Labstep
 *
 * @module components/OrderRequest/Form/Create/Bulk
 * @desc Form to bulk create order request
 */

import {
  DEFAULT_QUANTITY_VALUE,
  fieldQuantity,
  fieldUrgent,
} from 'labstep-web/components/OrderRequest/Form/fields';
import { EntityCreateContainer } from 'labstep-web/containers/Entity/Create';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import { OrderRequest } from 'labstep-web/models/order-request.model';
import type React from 'react';
import type { OrderRequestFormCreateBulkProps } from './types';

export const OrderRequestFormCreateBulk: React.FC<
  OrderRequestFormCreateBulkProps
> = ({ resources, options }) => {
  const fields: any = [fieldQuantity, fieldUrgent];
  return (
    <EntityCreateContainer entityName={OrderRequest.entityName} batch>
      {({ create, status }) => (
        <FormReusable
          defaultValues={{ quantity: DEFAULT_QUANTITY_VALUE }}
          status={status}
          autoFocus
          onSubmit={(values) =>
            create(
              resources.map((entity) => ({
                resource_id: entity.id,
                ...values,
              })),
              { ...options, toast: true, params: { no_output: 1 } },
            )
          }
          fields={fields}
          submitButtonText="Request"
        />
      )}
    </EntityCreateContainer>
  );
};
